import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface EmptyDropdownMessageProps {
  className?: string
  title?: React.ReactNode
  subtitle?: React.ReactNode
  imageSrc?: string
  imageSvg?: React.ReactElement
}

const EmptyDropdownMessage: React.FC<EmptyDropdownMessageProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      data-testid="emptyDropdownMessage"
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 30px;
        background-color: ${styleConstants.colors.white};
      `}
    >
      {props.imageSrc !== undefined && (
        <img
          css={css`
            margin-bottom: 20px;
          `}
          src={props.imageSrc}
          alt={''}
        />
      )}
      {props.imageSvg !== undefined && (
        <div
          css={css`
            margin-bottom: 20px;
          `}
        >
          {props.imageSvg}
        </div>
      )}
      <span
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
          margin-bottom: 20px;
          text-align: center;
        `}
      >
        {props.title || translate('No matching results')}
      </span>
      <span
        css={css`
          ${getFontCss(
            16,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )};
          text-align: center;
        `}
      >
        {props.subtitle ||
          translate(
            'Please check for any typos, or search for a different option.',
          )}
      </span>
    </div>
  )
}

export default EmptyDropdownMessage
